export const covidPolicy = {
    travelApp: {
        label: 'alohasafealert.org',
        url: 'https://www.alohasafealert.org/',
    },
    covid19: {
        label: 'hawaiicovid19.com',
        url: 'https://hawaiicovid19.com/',
    },
    furtherInformation: {
        label: 'mauicounty.gov',
        url: 'https://www.mauicounty.gov/',
    },
    policy: {
        general: [
            'generalTraining',
            'generalEstablishmentPosition',
            'cleaningStandards',
            'generalFaceMask',
            'generalTemperatureCheck',
            'generalExpandedFourSeasonsChat',
            'generalVirtualStaffInteractions',
            'generalUVLightCleaners',
            'generalTurnaroundTime',
            'generalArrivalScreeningProcess',
            'generalHealthGuidelines',
            'generalSanitizerStations',
            'generalRoomPCR',
        ],
        hotelEnhancements: [
            'hotelEnhancementsGuestTransportation',
            'hotelEnhancementsIncreasedPrivateOptions',
            'hotelEnhancementsPreArrival',
            'hotelEnhancementsExclusiveLounge',
            'hotelEnhancementsiPadTechnology',
        ],
        food: ['foodReducedOccupancy', 'foodMenusDigitally', 'foodPreorder'],
        resortAmenities: ['resortAmenitiesPool'],
        spa: [
            'spaExtensiveRetraining',
            'spaPPE',
            'spaPrivate',
            'spaWorkAndFacialTreatments',
            'spaExtendedTimeAllotted',
            'spaPlexiglass',
            'spaFaceCoverings',
            'spaShower',
            'spaCollateralAndPeriodicals',
        ],
        fitness: [
            'fitnessPPE',
            'fitnessAdditionalOptions',
            'fitnessModifiedFloorPlan',
            'fitnessReduceCapacity',
            'fitnessScheduleStaggered',
            'fitnessIndividualGuestStations',
        ],
    },
};
